import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.users.components';

export default defineMessages({
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    addUserLabel: {
        id: `${scope}.label.addUser`,
        defaultMessage: 'Add user',
    },
    editUserLabel: {
        id: `${scope}.label.editUser`,
        defaultMessage: 'Edit user',
    },
    deleteUserLabel: {
        id: `${scope}.label.deleteUser`,
        defaultMessage: 'Delete user',
    },
    nameColumnLabel: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    usernameColumnLabel: {
        id: `${scope}.grid.column.username`,
        defaultMessage: 'Username',
    },
    emailColumnLabel: {
        id: `${scope}.grid.column.email`,
        defaultMessage: 'Email',
    },
    rolesColumnLabel: {
        id: `${scope}.grid.column.roles`,
        defaultMessage: 'Roles',
    },
    unknownRoleNameTooltip: {
        id: `${scope}.tooltip.unknownRoleName`,
        defaultMessage: 'Unknown role name for id {id}',
    },
    departmentsLabel: {
        id: `${scope}.label.departments`,
        defaultMessage: 'Departments (maintenance)',
    },
    departmentsHelp: {
        id: `${scope}.help.departments`,
        defaultMessage: 'Controls which work order notifications the user receives.',
    },
    departmentsSaveError: {
        id: `${scope}.error.departmentsSave`,
        defaultMessage: 'The user was saved, but the departments could not be updated.',
    },
    departmentsLoading: {
        id: `${scope}.label.departmentsLoading`,
        defaultMessage: 'Loading the current departments…',
    },
    departmentsLoadError: {
        id: `${scope}.error.departmentsLoad`,
        defaultMessage: 'The departments could not be loaded. They are left unchanged when you save.',
    },
});